/**
 * @module lib/election-services
 * @description Federal Election JSON data URLs. Either live, mock, or archived Dropbox URLs.
 */
import tgamConfig from "config/tgam";

/**
 * Get the Federal Election Interactive Map Ridings region data feed URL.
 * e.g. https://www.theglobeandmail.com/files/dev/components/elections/2021/federal-election-ridings.json
 * @param {String} [year=""]
 * @returns {String} of URL
 */
export function electionMapRidingsUrl(year = "") {
  if (["2019", "2021"].includes(year)) {
    return `https://www.theglobeandmail.com/files/dev/components/elections/${year}/map_ridings.json`;
  }
  return tgamConfig.env.electionMapRidingsUrl;
}

/**
 * Get the Federal Election Leading party data feed URL.
 * e.g. https://www.theglobeandmail.com/files/dev/components/elections/2021/federal-election-ridings.json
 * @param {String} [year=""]
 * @returns {String} of URL
 */
export function electionLeadingUrl(year = "") {
  if (/mockLeading=true/.test(window.location.search)) {
    return tgamConfig.env.awsLeadingMockUrl;
  }
  if (["2019", "2021"].includes(year)) {
    return `https://www.theglobeandmail.com/files/dev/components/elections/${year}/federal-election-leading.json`;
  }
  const token = Math.floor(new Date().getTime() / 1000);
  return `${tgamConfig.env.awsLeadingDataUrl}?_=${token}`;
}

/**
 * Get the Federal Election Key Ridings data feed URL.
 * e.g. https://www.theglobeandmail.com/files/dev/components/elections/2021/federal-election-ridings.json
 * @param {String} [year=""]
 * @returns {String} of URL
 */
export function electionRidingUrl(year = "") {
  if (/mockRiding=true/.test(window.location.search)) {
    return tgamConfig.env.awsLeadingMockUrl;
  }
  if (["2019", "2021"].includes(year)) {
    return `https://www.theglobeandmail.com/files/dev/components/elections/${year}/federal-election-ridings.json`;
  }
  const token = Math.floor(new Date().getTime() / 1000);
  return `${tgamConfig.env.awsRidingDataUrl}?_=${token}`;
}
